// extracted by mini-css-extract-plugin
export default {"footerWrapper":"Footer_footerWrapper__+vpvQ","footer":"Footer_footer__cOQNQ","logos":"Footer_logos__olsa+","icon":"Footer_icon__AaSzF","copyright":"Footer_copyright__FJOSH"};